import { Component, OnDestroy, OnInit } from '@angular/core';
import { OfferedtripsService } from '../offered-trips-service/offeredtrips.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit, OnDestroy {
  search = '';
  logsList = [];

  constructor(
    private offeredTripsService: OfferedtripsService
  ) { }

  ngOnInit() {
    this.getLogs();
  }

  getLogs() {
    this.offeredTripsService
      .getTripsLogs()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.logsList = data;
        }
      });
  }

  ngOnDestroy(): void {
  }
}
